import React from 'react';
import { Form, Errors } from 'react-redux-form';
import Dropzone from 'react-dropzone';
import BaseDetailScreen from '../BaseDetailScreen';
import { SUPPORT_EMAIL } from '../../actions/urls';
import UploadVerifyDocsForm from '../Forms/UploadVerifyDocs';
import { baseUploadVerifyDocsPath } from '../Forms/Schemas/baseRrf';
import Button from '../Button';
import blueCheck from '../../assets/images/blue_confirmation_check.png';
import loadingGif from '../../assets/images/loading.gif';

import './styles.css';

const UploadVerifyDocs = (props) => {
  const {
    accountNumber,
    docTypeOptions,
    fileName,
    onDrop,
    onSubmit,
    fileErrors,
    showDropzone,
    instructions,
    isLoading,
    isComplete,
  } = props;
  const disableSubmit = fileName === 'No file selected' || (fileErrors && fileErrors.length > 0);
  // Upload Docs Form
  let comp = (
    <Form
      onSubmit={this.onSubmit}
      model={baseUploadVerifyDocsPath}
      validators={{
        '': {
          hasFileErrors: () =>
            (fileErrors && fileErrors.length <= 0),
        },
      }}
    >
      <UploadVerifyDocsForm
        docTypeOptions={docTypeOptions}
        uploadDocsPath={baseUploadVerifyDocsPath}
      />
      {showDropzone ?
        <React.Fragment>
          <Dropzone
            onDrop={onDrop}
            style={{
              width: '100%',
              height: '230px',
              border: 'solid 1px #c2d6e9',
            }}
            disablePreview
            multiple={false}
          />
          <div styleName="instruct">
            {instructions}
          </div>
          <div styleName="docName">
            {fileName}
          </div>
        </React.Fragment> : null}
      <Errors
        styleName="errorText"
        component={compProps => <div>{compProps.children}</div>}
        model={baseUploadVerifyDocsPath}
        messages={{
            hasFileErrors: (
              fileErrors && fileErrors.map(err => <div key={err}>{err}</div>)
            ),
          }}
      />
      <div styleName="submitBtn">
        <Button
          onClick={onSubmit}
          disabled={disableSubmit}
          type="submit"
        >
          Upload
        </Button>
      </div>
    </Form>
  );
  // Success view
  if (isComplete) {
    comp = (
      <div styleName="successGroup">
        <img
          src={blueCheck}
          alt="Checkmark"
          styleName="successCheck"
        />
        <div styleName="successText">Upload complete!</div>
      </div>
    );
  }
  // Loading view
  if (isLoading) {
    comp = (
      <div styleName="successGroup">
        <img
          src={loadingGif}
          alt="Loading"
          styleName="loading"
        />
        <div styleName="successText">Uploading...</div>
      </div>
    );
  }
  return (
    <BaseDetailScreen
      pageHeading="Upload Document"
      backTo={`/account/${accountNumber}`}
      backLabel="Manage Account"
      pageSubheading={
        <div styleName="restrictMessage">
          Restriction lifting is a manual process, please wait 3 - 5 business days to
          see the restriction lifted. If you have further issues please&nbsp;
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            styleName="restrictLink"
          >
            contact support.
          </a>
        </div>}
    >
      <div styleName="uploadDocs">
        {comp}
      </div>
    </BaseDetailScreen>
  );
};

export default UploadVerifyDocs;



// WEBPACK FOOTER //
// ./src/components/UploadVerifyDocs/UploadVerifyDocs.js